export default __webpack_public_path__ + "static/media/brasileirada.58bf8ca8.jpg";